import React from 'react';
import AuthenticationLayout from '../../componentsV2/Layouts/AuthenticationLayout';
import SignupForm from './components/SignupForm';

const SignupPage: React.FC = () => {
  return <AuthenticationLayout leftSide={<SignupForm />} rightSide={<p></p>} />;
};

export default SignupPage;
